import { ViewModel, ObservableArray, View } from "binder";
import moment from "moment";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";
import { CodeConversionCofrimDetailViewModel } from "../codeConversionCofrimDetail/codeConversionCofrimDetail-viewModel";
import { InternalTransferStatusEnumProvider, TransferType, TransferStatus } from "../internalTransferList/internalTransferList-viewModel";
import { CodeConversionCofrimListView } from "./codeConversionCofrimList-view";
import { ReceiptFormViewModel } from "../receiptForm/receiptForm-viewModel";

export class CodeConversionCofrimListViewModel extends WindowViewModel {
    public getTitle(): string {
        return "تایید کد به کد";
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.codeConversions = ObservableArray.create<CodeConversion>();
        this.loader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 15);
        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new CodeConversionCofrimListView();
    }
    public getTypeId(): string {
        return "VM-CA0CBFC9-705D-4C40-A94A-F0DF2BCA7C18"
    }

    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set codeConversions(v: ObservableArray<CodeConversion>) { this._codeConversions = v; } public get codeConversions(): ObservableArray<CodeConversion> { return this._codeConversions; } private _codeConversions: ObservableArray<CodeConversion>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set internalTransferStatusEnumProvider(v: InternalTransferStatusEnumProvider) { this._internalTransferStatusEnumProvider = v; } public get internalTransferStatusEnumProvider(): InternalTransferStatusEnumProvider { return this._internalTransferStatusEnumProvider; } private _internalTransferStatusEnumProvider: InternalTransferStatusEnumProvider;

    refresh() {
        this.loader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            if (filteringInformation.OrderInfo.length == 0) {
                let sort = {
                    fieldName: 'creationTime',
                    order: 'DESC',
                    type: 'date'
                };
                filteringInformation.OrderInfo = [sort];
            }

            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseTransferServices/ListAllInternalWarehouseTransfers', {
                FurtherQueryInfo: filteringInformation,
                TransferType: TransferType.CodeConversion
            });
            this.codeConversions.update(...result.Requests.map((q, i) => {
                let r = new CodeConversion(this);
                r.rowNumber = i + 1;
                r.transferId = q.Id;
                r.orderCode = q.OrderCode;
                r.canOrder = stringIsNullOrEmpty(q.OrderCode) && q.TransferStatus != 3;
                r.canReceipt = stringIsNullOrEmpty(q.OrderCode) == false && stringIsNullOrEmpty(q.ReceiptCode);
                r.canReject = stringIsNullOrEmpty(q.OrderCode) && stringIsNullOrEmpty(q.ReceiptCode) && q.TransferStatus != 3;
                r.issueTime = moment.utc(q.IssueTime);
                r.orderTime = q.OrderTime == null ? null : moment.utc(q.OrderTime);
                r.receiptTime = q.ReceiptTime == null ? null : moment.utc(q.ReceiptTime);
                r.fromWarehouseId = q.FromWarehouseId;
                r.fromWarehouseName = q.FromWarehouseName;
                r.toWarehouseId = q.ToWarehouseId;
                r.toWarehouseName = q.ToWarehouseName;
                r.receiptCode = q.ReceiptCode;
                r.comment = q.Comment;
                r.transferStatus = q.TransferStatus as TransferStatus
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    refreshClosePopups() {
        this.isShowingPopup = false;
        this.refresh();
    }

    async showDetail(id: string) {
        let invoiceDetail = new CodeConversionCofrimDetailViewModel(this, id);
        let result = await this.showPopup(invoiceDetail);
    }
    
    async showReceiptForm(id: string) {
        let invoiceDetail = new ReceiptFormViewModel(this, id);
        let result = await this.showPopup(invoiceDetail);
    }
}

export class CodeConversion extends ViewModel {

    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: CodeConversionCofrimListViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;
    public set fromWarehouseId(v: string) { this._fromWarehouseId = v; } public get fromWarehouseId(): string { return this._fromWarehouseId; } private _fromWarehouseId: string;
    public set fromWarehouseName(v: string) { this._fromWarehouseName = v; } public get fromWarehouseName(): string { return this._fromWarehouseName; } private _fromWarehouseName: string;
    public set toWarehouseId(v: string) { this._toWarehouseId = v; } public get toWarehouseId(): string { return this._toWarehouseId; } private _toWarehouseId: string;
    public set toWarehouseName(v: string) { this._toWarehouseName = v; } public get toWarehouseName(): string { return this._toWarehouseName; } private _toWarehouseName: string;
    public set transferId(v: string) { this._transferId = v; } public get transferId(): string { return this._transferId; } private _transferId: string;
    public set orderCode(v: number) { this._orderCode = v; } public get orderCode(): number { return this._orderCode; } private _orderCode: number;
    public set issueTime(v: moment.Moment) { this._issueTime = v; } public get issueTime(): moment.Moment { return this._issueTime; } private _issueTime: moment.Moment;
    public set orderTime(v: moment.Moment) { this._orderTime = v; } public get orderTime(): moment.Moment { return this._orderTime; } private _orderTime: moment.Moment;
    public set receiptTime(v: moment.Moment) { this._receiptTime = v; } public get receiptTime(): moment.Moment { return this._receiptTime; } private _receiptTime: moment.Moment;
    public set receiptCode(v: string) { this._receiptCode = v; } public get receiptCode(): string { return this._receiptCode; } private _receiptCode: string;
    public set canOrder(v: boolean) { this._canOrder = v; } public get canOrder(): boolean { return this._canOrder; } private _canOrder: boolean;
    public set canReceipt(v: boolean) { this._canReceipt = v; } public get canReceipt(): boolean { return this._canReceipt; } private _canReceipt: boolean;
    public set canReject(v: boolean) { this._canReject = v; } public get canReject(): boolean { return this._canReject; } private _canReject: boolean;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment; } private _comment: string;
    public set transferStatus(v: TransferStatus) { this._transferStatus = v; } public get transferStatus(): TransferStatus { return this._transferStatus; } private _transferStatus: TransferStatus;

    private _typedParent: CodeConversionCofrimListViewModel;

    async showDetail() {
        this._typedParent.showDetail(this.transferId);
    }

    async order() {
        try {
            let confirmation = '';
            confirmation = await this.messageBoxWarningYesNo('آیا این سطر حواله شود؟', 'درخواست حواله');
            if (confirmation == 'no') {
                return;
            }
            this._typedParent.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseTransferServices/CreateOrderForInternalTransfer', {
                TransferType: TransferType.CodeConversion,
                InternalTransfer: this.transferId
            });
            if (result.IsSuccessful == true) {
                await this.messageBoxConfirmSuccess('حواله با موفقیت ثبت شد.', 'عملیات موفق');
                this._typedParent.refresh();
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات', 'خطا');
        } finally {
            this._typedParent.isLoading = false;
        }
    }

    async receipt() {
        try {
            this._typedParent.showReceiptForm(this.transferId);
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات', 'خطا');
        } finally {
            this._typedParent.isLoading = false;
        }
    }

    async reject() {
        try {
            let confirmation = '';
            confirmation = await this.messageBoxWarningYesNo('آیا این سطر رد شود؟', 'درخواست رد');
            if (confirmation == 'no') {
                return;
            }
            this._typedParent.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseTransferServices/RejectInternalTransfer', {
                InternalTransfer: this.transferId
            });
            if (result.IsSuccessful == true) {
                await this.messageBoxConfirmSuccess('تغییرات با موفقیت ثبت شد.', 'عملیات موفق');
                this._typedParent.refresh();
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات', 'خطا');
        } finally {
            this._typedParent.isLoading = false;
        }
    }

}